export default __webpack_public_path__ + "static/media/bacqueville8.b02fef93.jpg";